import { statusTypes, licenseTypes, certificateTypes, degreeLevels } from '../config/constants';
import genericValidationMethods, { getValidationState } from './genericValidation';

export function ProfessionalValidation(colleges = []) {
  this.rules = {
    degrees: {
      validationMethod: 'getDegreesValidationState',
      errorMsg: 'Incomplete Degree Information',
      id: 'degrees'
    },
    licenses: {
      validationMethod: 'getLicensesValidationState',
      errorMsg: 'Incomplete License Information',
      id: 'licenses'
    },
    certificates: {
      validationMethod: 'getCertificatesValidationState',
      errorMsg: 'Incomplete Certificate Information',
      id: 'certificates'
    }
  };
  this.getDegreesValidationState = function(degrees) {
    const problemDegrees = degrees.filter((degree) => new DegreeValidation(colleges).getValidationStatus(degree).section.status !== statusTypes.SUCCESS);
    return problemDegrees.length === 0 ? statusTypes.SUCCESS : statusTypes.ERROR;
  };
  this.getLicensesValidationState = function(licenses) {
    const problemLicenses = licenses.filter((license) => new LicenseValidation().getValidationStatus(license).section.status !== statusTypes.SUCCESS);
    return problemLicenses.length === 0 ? statusTypes.SUCCESS : statusTypes.ERROR;
  };
  this.getCertificatesValidationState = function(certificates) {
    const problemCertificates = certificates.filter((certificate) => new CertificateValidation().getValidationStatus(certificate).section.status !== statusTypes.SUCCESS);
    return problemCertificates.length === 0 ? statusTypes.SUCCESS : statusTypes.ERROR;
  };

  this.getStringValidationState = genericValidationMethods.getStringValidationState;
  this.getValidationStatus = getValidationState.bind(this);
}

export function DegreeValidation(colleges = []) {
  const collegeOptions = colleges.map(college => college.id);
  this.rules = {
    school: {
      validationMethod: 'getEnumValidationState',
      errorMsg: 'Missing School',
      id: 'school',
      options: collegeOptions
    },
    level: {
      validationMethod: 'getEnumValidationState',
      errorMsg: 'Missing Degree Level',
      id: 'level',
      options: Object.keys(degreeLevels)
    },
    name: {
      validationMethod: 'getStringValidationState',
      errorMsg: 'Missing Degree Name',
      id: 'name'
    },
    date: {
      validationMethod: 'getDateValidationState',
      errorMsg: 'Missing Degree Date',
      id: 'date'
    }
  };
  this.getStringValidationState = genericValidationMethods.getStringValidationState;
  this.getEnumValidationState = genericValidationMethods.getEnumValidationState;
  this.getDateValidationState = genericValidationMethods.getDateValidationState;
  this.getValidationStatus = getValidationState.bind(this);
}

export function LicenseValidation() {
  this.rules = {
    type: {
      validationMethod: 'getEnumValidationState',
      errorMsg: 'Missing License Type',
      id: 'type',
      options: Object.keys(licenseTypes)
    },
    number: {
      validationMethod: 'getStringValidationState',
      errorMsg: 'Missing License Number',
      id: 'number'
    },
    expirationDate: {
      validationMethod: 'getDateValidationState',
      errorMsg: 'Missing Expiration Date',
      id: 'expirationDate'
    }
  };
  this.getStringValidationState = genericValidationMethods.getStringValidationState;
  this.getEnumValidationState = genericValidationMethods.getEnumValidationState;
  this.getDateValidationState = genericValidationMethods.getDateValidationState;
  this.getValidationStatus = getValidationState.bind(this);
}

export function CertificateValidation() {
  this.rules = {
    type: {
      validationMethod: 'getEnumValidationState',
      errorMsg: 'Missing Certificate Type',
      id: 'type',
      options: Object.keys(certificateTypes)
    },
    number: {
      validationMethod: 'getStringValidationState',
      errorMsg: 'Missing Certificate Number',
      id: 'number'
    },
    expirationDate: {
      validationMethod: 'getDateValidationState',
      errorMsg: 'Missing Expiration Date',
      id: 'expirationDate'
    }
  };
  this.getStringValidationState = genericValidationMethods.getStringValidationState;
  this.getEnumValidationState = genericValidationMethods.getEnumValidationState;
  this.getDateValidationState = genericValidationMethods.getDateValidationState;
  this.getValidationStatus = getValidationState.bind(this);
}

export default ProfessionalValidation;